// extracted by mini-css-extract-plugin
export var table = "_uz-0";